function createCache(limit = 20) {
    const defaultCacheState = {
        data: new Map(),
        limit,
    };

    const cache = {
        ...defaultCacheState,

        searchMinUsesNumber() {
            let min = {};
            this.data.forEach(({ usesNumber }, payload) => {
                if (usesNumber < min.usesNumber || !min.usesNumber) {
                    min = { usesNumber, payload };
                }
            });
            return min.payload;
        },

        delete(payload) {
            this.data.delete(payload);
        },

        getPromiseStatus(p) {
            const t = {};
            return Promise.race([p, t]).then(
                v => (v === t ? 'pending' : 'fulfilled'),
                () => 'rejected',
            );
        },

        /**
         *
         * @param {object} payload - тело запроса (используется в качестве ключа для хранения данных в кэше по умолчанию)
         * @param {function} fetcher - функция, выполняющая запрос на сервер
         * @returns - данные из запроса
         */

        async get(payload, fetcher) {
            const payloadKey = JSON.stringify(payload);
            const cached = this.data.get(payloadKey);

            if (cached) {
                cached.usesNumber += 1;
                return cached.data;
            }

            if (this.data.size >= this.limit) {
                const leastUsedPayload = this.searchMinUsesNumber();
                if (leastUsedPayload) this.delete(leastUsedPayload);
            }

            try {
                const data = await fetcher(payload);
                this.data.set(payloadKey, { usesNumber: 1, data });
                return data;
            } catch (error) {
                console.error('Cache fetch failed:', error);
                throw error;
            }
        },
    };
    return cache;
}

export default createCache;
